import { TeacherRole } from '../views/TeacherManagement/TeacherActivation/types';

export interface TeacherAccountData {
  birthday: string;
  name: string;
  paternalLastName: string;
  maternalLastName: string;
  email: string;
  personalEmail?: string;
  status: TeacherAccountStatus;
  lastLogin: string | null;
  run: string;
  identification: string;
  teacherRoleId: TeacherRole;
  campusId?: string | number;
  schoolId?: string | number;
  id?: number;
}

export enum TeacherAccountStatus {
  ACTIVE = 'active',
  INACTIVE = 'no active',
}
